import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import useSWRMutation, { type SWRMutationConfiguration } from "swr/mutation";

type UnlikeCommentInput = {
  predictionMarketId: string;
  commentId: string;
};

const fetcher = async (
  _url: string,
  { arg: { predictionMarketId, commentId } }: { arg: UnlikeCommentInput },
): Promise<void> => {
  const headers = authHeader.getOrThrow();
  await romanApi.post(`/prediction-market/${predictionMarketId}/comments/${commentId}/unlike`, {}, { headers });
};

export const useUnlikeComment = (options?: {
  onSuccess?: () => void;
  onError?: () => void;
  swrOptions?: SWRMutationConfiguration<void, RomanApiError, string, UnlikeCommentInput>;
}) => {
  const { onSuccess, onError, swrOptions } = options || {};

  const mergedOptions = {
    ...swrOptions,
    onSuccess: () => onSuccess?.(),
    onError: () => onError?.(),
  };

  const { trigger, error, isMutating } = useSWRMutation<void, RomanApiError, string, UnlikeCommentInput>(
    "unlike-comment",
    fetcher,
    mergedOptions,
  );

  return {
    unlikeComment: trigger,
    isMutating,
    error,
  };
};
